<template>
  <v-card flat color="background">
    <v-banner icon="local_shipping">Delivery Days</v-banner>
    <v-data-table :headers="headers" :items="daysItems" hide-default-footer>
      <template v-slot:item.deliveryDayMonday="{item,value}">
        <v-icon color="success" v-if="value == '1'">check_circle_outline</v-icon>
        <v-icon color="error" v-else>cancel</v-icon>
      </template>
      <template v-slot:item.deliveryDayTuesday="{item,value}">
        <v-icon color="success" v-if="value == '1'">check_circle_outline</v-icon>
        <v-icon color="error" v-else>cancel</v-icon>
      </template>
      <template v-slot:item.deliveryDayWednesday="{item,value}">
        <v-icon color="success" v-if="value == '1'">check_circle_outline</v-icon>
        <v-icon color="error" v-else>cancel</v-icon>
      </template>
      <template v-slot:item.deliveryDayThursday="{item,value}">
        <v-icon color="success" v-if="value == '1'">check_circle_outline</v-icon>
        <v-icon color="error" v-else>cancel</v-icon>
      </template>
      <template v-slot:item.deliveryDayFriday="{item,value}">
        <v-icon color="success" v-if="value == '1'">check_circle_outline</v-icon>
        <v-icon color="error" v-else>cancel</v-icon>
      </template>
      <template v-slot:item.deliveryDaySaturday="{item,value}">
        <v-icon color="success" v-if="value == '1'">check_circle_outline</v-icon>
        <v-icon color="error" v-else>cancel</v-icon>
      </template>
      <template v-slot:item.deliveryDaySunday="{item,value}">
        <v-icon color="success" v-if="value == '1'">check_circle_outline</v-icon>
        <v-icon color="error" v-else>cancel</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomerDeliveryDays",
  data: () => {
    return {
      headers: [
        { text: "Monday", value: "deliveryDayMonday", sortable: false },
        { text: "Tuesday", value: "deliveryDayTuesday", sortable: false },
        { text: "Wednesday", value: "deliveryDayWednesday", sortable: false },
        { text: "Thursday", value: "deliveryDayThursday", sortable: false },
        { text: "Friday", value: "deliveryDayFriday", sortable: false },
        { text: "Saturday", value: "deliveryDaySaturday", sortable: false },
        { text: "Sunday", value: "deliveryDaySunday", sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters(["retrieveCustomerDeilveryDays"]),
    daysItems() {
      let arrayOfDays = [];
      JSON.stringify(this.retrieveCustomerDeilveryDays, function(key, value) {
        arrayOfDays.push(value);
      });
      return arrayOfDays;
    }
  }
};
</script>